import { useTranslation } from 'react-i18next';

// The toggle has two axes. Tables use Cell/Table; prose carriers (paragraph, list)
// use Text/Block. See .claude/specs/block-tagging-paragraphs-lists.
export type BlockScope = 'cell' | 'table' | 'text' | 'block';
export type ScopeAxis = 'table' | 'prose' | 'list';

const AXIS_OPTIONS = {
  table: [
    ['cell', 'scope.cell'],
    ['table', 'scope.table'],
  ],
  prose: [
    ['text', 'scope.text'],
    ['block', 'scope.block'],
  ],
  list: [
    ['text', 'scope.list.text'],
    ['block', 'scope.list.block'],
  ],
} as const satisfies Record<ScopeAxis, readonly (readonly [BlockScope, string])[]>;

interface ScopeToggleProps {
  scope: BlockScope;
  onChange: (next: BlockScope) => void;
  axis?: ScopeAxis;
}

export const ScopeToggle = ({ scope, onChange, axis = 'table' }: ScopeToggleProps) => {
  const { t } = useTranslation('tag');

  const options = AXIS_OPTIONS[axis];
  return (
    <div className="tags-footer__scope" role="radiogroup" aria-label={t('scope.label')}>
      {options.map(([value, label]) => (
        <label key={value} className="tags-footer__scope-option">
          <input type="radio" name="block-tag-scope" value={value} checked={scope === value} onChange={() => onChange(value)} />
          {t(label)}
        </label>
      ))}
    </div>
  );
};
